import { GAME_CATEGORY_FILTER } from 'core/constants';
import { IconAll } from 'components/icons/icons-games-filters/icon-all';
import { IconLive } from 'components/icons/icons-games-filters/icon-live';
import { IconSlots } from 'components/icons/icons-games-filters/icon-slots';
import { IconSport } from 'components/icons/icons-games-filters/icon-sport';
import { IconOtherGames } from 'components/icons/icons-games-filters/icon-other-games';
import { IconRoulette } from 'components/icons/icons-games-filters/icon-roulette';
import { IconBlackjack } from 'components/icons/icons-games-filters/icon-blackjack';
import { IconJackpot } from 'components/icons/icons-games-filters/icon-jackpot';

export const GAMES_CATEGORIES_ICONS = {
  [GAME_CATEGORY_FILTER.ALL]: IconAll,
  [GAME_CATEGORY_FILTER.LIVE_CASINO]: IconLive,
  [GAME_CATEGORY_FILTER.SLOTS]: IconSlots,
  [GAME_CATEGORY_FILTER.ROULETTE]: IconRoulette,
  [GAME_CATEGORY_FILTER.CARD_GAMES]: IconBlackjack,
  [GAME_CATEGORY_FILTER.SPORT]: IconSport,
  [GAME_CATEGORY_FILTER.JACKPOTS]: IconJackpot,
};

export const CATEGORIES_ITEMS = [
  {
    Icon: IconAll,
    key: 'games.category.all',
    category: GAME_CATEGORY_FILTER.ALL,
    to: 'all',
  },
  {
    Icon: IconLive,
    key: 'games.category.live',
    category: GAME_CATEGORY_FILTER.LIVE_CASINO,
    to: 'live',
  },
  {
    Icon: IconSlots,
    key: 'games.category.slot',
    category: GAME_CATEGORY_FILTER.SLOTS,
    to: 'slot',
  },
  {
    Icon: IconJackpot,
    key: 'games.category.jackpots',
    category: GAME_CATEGORY_FILTER.JACKPOTS,
    to: 'jackpots',
  },
  {
    Icon: IconRoulette,
    key: 'games.category.roulette',
    category: GAME_CATEGORY_FILTER.ROULETTE,
    to: 'roulette',
  },
  {
    Icon: IconBlackjack,
    key: 'games.category.card',
    category: GAME_CATEGORY_FILTER.CARD_GAMES,
    to: 'card',
  },
  {
    Icon: IconOtherGames,
    key: 'games.category.sport',
    category: GAME_CATEGORY_FILTER.SPORT,
    to: 'sport',
  }
];
